import { render, staticRenderFns } from "./PendingInvitationDetails.vue?vue&type=template&id=083c6906"
import script from "./PendingInvitationDetails.vue?vue&type=script&lang=js"
export * from "./PendingInvitationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports